import { render, staticRenderFns } from "./ListMetal.vue?vue&type=template&id=749b05dd"
import script from "./ListMetal.vue?vue&type=script&lang=js"
export * from "./ListMetal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports